import React, { useEffect } from 'react'
import ServicesSection from '../../components/common/ServicesSection'
import PageTitle from '../../components/common/PageTitle'
import ServicesCard from '../../components/cards/ServicesCard'
import WhyUsSection from '../../components/common/WhyUsSection'
import { useDispatch, useSelector } from 'react-redux'
import { getServices } from '../../services/actions/MainAction'
import { Sparkles } from 'lucide-react'

function Services() {
  const contentData = useSelector(state => state.Data.contentData);
  const lang_id = useSelector(state => state.Data.lang_id);
  const services = useSelector(state => state.Data.services);
  const dispatch = useDispatch()
   useEffect(()=>{
      window.scrollTo(0,0);
      dispatch(getServices(lang_id))
    },[lang_id]);
  return (
    <main className='mt-[0px] min-h-[80vh]'>
      <div className="relative overflow-hidden bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 py-16">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 border-2 border-blue-400 rounded-full animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-48 h-48 border-2 border-amber-400 rounded-full animate-pulse"></div>
        </div>

        <div className="relative container mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/20 rounded-full mb-6 border border-blue-400/30 backdrop-blur-sm">
              <Sparkles className="w-4 h-4 text-blue-300" />
              <span className="text-sm font-medium text-blue-100">{contentData?.nav_2}</span>
              <Sparkles className="w-4 h-4 text-amber-300" />
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight">
              <span className="bg-gradient-to-r from-white via-blue-100 to-white bg-clip-text text-transparent">
                {contentData?.nav_2}
              </span>
            </h1>
          </div>
        </div>
      </div>
      <div className='container2'>
        <div className='grid grid-cols-4 gap-[40px]  relative mt-[30px] max-[1200px]:grid-cols-3 gap-y-[20px] max-[800px]:grid-cols-2 max-[500px]:grid-cols-1 gap-y-[0px]'>
          {
            services?.map((data, i) => {
              return (
                 <ServicesCard 
                  key={i}
                  data={data}
                 />
              )
            })
          }
        </div>
      </div>
      <WhyUsSection />
    </main>
  )
}

export default Services
